import { useEffect, useRef, useState } from 'react';

export default function AdminNotificacoes() {
  const [usuarios,  setUsuarios]  = useState([]);
  const [destino,   setDestino]   = useState('');   // '' = todos
  const [mensagem,  setMensagem]  = useState('');
  const [sending,   setSending]   = useState(false);
  const [toast,     setToast]     = useState(null);
  const toastTimer = useRef(null);

  function showToast(msg, type = 'success') {
    setToast({ msg, type });
    clearTimeout(toastTimer.current);
    toastTimer.current = setTimeout(() => setToast(null), 4000);
  }

  useEffect(() => {
    fetch('/admin/users-list-json', { credentials: 'include' })
      .then(r => r.json())
      .then(setUsuarios)
      .catch(() => {});
  }, []);

  async function enviar(e) {
    e.preventDefault();
    if (!mensagem.trim()) return;
    setSending(true);

    const targets = destino ? [Number(destino)] : usuarios.map(u => u.id);
    let ok = 0; let fail = 0;

    for (const uid of targets) {
      try {
        const res = await fetch('/admin/send-notification-json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ userlogin_id: uid, mensagem: mensagem.trim() }),
        });
        if (res.ok) ok++; else fail++;
      } catch { fail++; }
    }

    setSending(false);
    if (fail === 0) {
      showToast(`✓ Notificação enviada para ${ok} usuário${ok > 1 ? 's' : ''}!`);
      setMensagem('');
      setDestino('');
    } else {
      showToast(`${ok} enviadas, ${fail} falhas.`, 'error');
    }
  }

  return (
    <div style={{ padding:'28px 24px', maxWidth:640, margin:'0 auto', fontFamily:'Poppins, sans-serif' }}>
      <h1 style={{ fontSize:'1.6rem', fontWeight:800, color:'#1a2a4a', marginBottom:24, display:'flex', alignItems:'center', gap:10 }}>
        <i className="fas fa-bell" style={{ color:'#10b981' }} />
        Enviar Notificação
      </h1>

      <div style={{ background:'#fff', borderRadius:18, padding:28, boxShadow:'0 4px 20px rgba(0,0,0,0.08)' }}>
        <form onSubmit={enviar} style={{ display:'flex', flexDirection:'column', gap:18 }}>

          {/* Destinatário */}
          <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
            <label style={{ fontWeight:700, fontSize:'0.85rem', color:'#475569' }}>
              Destinatário
            </label>
            <select
              value={destino}
              onChange={e => setDestino(e.target.value)}
              style={{
                padding:'10px 14px', border:'1.5px solid #e2e8f0', borderRadius:10,
                fontFamily:'Poppins, sans-serif', fontSize:'0.92rem', background:'#f8fafc', color:'#1a2a4a', outline:'none',
              }}
            >
              <option value="">📢 Todos os usuários ({usuarios.length})</option>
              {usuarios.map(u => (
                <option key={u.id} value={u.id}>{u.nome} — {u.email}</option>
              ))}
            </select>
          </div>

          {/* Mensagem */}
          <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
            <label style={{ fontWeight:700, fontSize:'0.85rem', color:'#475569' }}>
              Mensagem <span style={{ color:'#ef4444' }}>*</span>
            </label>
            <textarea
              value={mensagem}
              onChange={e => setMensagem(e.target.value)}
              placeholder="Digite a mensagem da notificação..."
              required
              rows={5}
              style={{
                padding:'12px 14px', border:'1.5px solid #e2e8f0', borderRadius:10,
                fontFamily:'Poppins, sans-serif', fontSize:'0.92rem', resize:'vertical',
                background:'#f8fafc', color:'#1a2a4a', outline:'none',
                direction:'ltr', textAlign:'left',
                transition:'border-color 0.2s',
              }}
              onFocus={e => e.target.style.borderColor = '#10b981'}
              onBlur={e => e.target.style.borderColor = '#e2e8f0'}
            />
            <span style={{ fontSize:'0.75rem', color:'#94a3b8', textAlign:'right' }}>
              {mensagem.length} caracteres
            </span>
          </div>

          {/* Preview */}
          {mensagem.trim() && (
            <div style={{ background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:10, padding:'12px 16px' }}>
              <div style={{ fontSize:'0.75rem', fontWeight:700, color:'#16a34a', marginBottom:4, textTransform:'uppercase', letterSpacing:'0.5px' }}>
                Preview
              </div>
              <div style={{ fontSize:'0.9rem', color:'#15803d', fontWeight:400 }}>{mensagem}</div>
              <div style={{ fontSize:'0.75rem', color:'#94a3b8', marginTop:6 }}>
                Será enviada para: {destino
                  ? `${usuarios.find(u => u.id === Number(destino))?.nome}`
                  : `todos os ${usuarios.length} usuários`}
              </div>
            </div>
          )}

          <button
            type="submit"
            disabled={sending || !mensagem.trim()}
            style={{
              padding:'13px', border:'none', borderRadius:12,
              background: sending ? '#94a3b8' : 'linear-gradient(135deg, #10b981, #34d399)',
              color:'#fff', fontFamily:'Poppins, sans-serif', fontSize:'0.95rem', fontWeight:700,
              cursor: sending ? 'not-allowed' : 'pointer',
              display:'flex', alignItems:'center', justifyContent:'center', gap:8,
              transition:'opacity 0.2s',
            }}
          >
            <i className={`fas fa-${sending ? 'spinner fa-spin' : 'paper-plane'}`} />
            {sending ? 'Enviando...' : `Enviar Notificação${destino ? '' : ` para todos (${usuarios.length})`}`}
          </button>
        </form>
      </div>

      {toast && (
        <div style={{
          position:'fixed', bottom:90, right:24, padding:'11px 22px', borderRadius:10,
          color:'#fff', fontSize:'0.88rem', fontWeight:600, zIndex:9999,
          background: toast.type === 'success' ? '#059669' : '#dc2626',
          boxShadow:'0 4px 16px rgba(0,0,0,0.15)', fontFamily:'Poppins, sans-serif',
          animation:'fadeInRight 0.3s ease',
        }}>
          {toast.msg}
        </div>
      )}
    </div>
  );
}
